import { createFileRoute } from "@tanstack/react-router";

import { VS_FIGMA_FAQS } from "@/components/Mcp/mcpArticleFaqs";
import { MCP_ARTICLES } from "@/components/Mcp/mcpArticles";
import { mcpArticleHead } from "@/components/Mcp/mcpHead";
import { McpVsFigmaPage } from "@/components/Mcp/McpVsFigmaPage";

const article = MCP_ARTICLES.find((a) => a.slug === "flowstep-vs-figma-mcp")!;

export const Route = createFileRoute("/mcp/flowstep-vs-figma-mcp")({
  component: McpVsFigmaPage,
  head: () =>
    mcpArticleHead({
      title: article.metaTitle,
      description: article.metaDescription,
      path: "/mcp/flowstep-vs-figma-mcp",
      breadcrumbName: article.name,
      faqs: VS_FIGMA_FAQS,
    }),
});
